module.exports = __webpack_public_path__ + "static/media/sala4.48e74757.webp";